import PasswordStrength from './PasswordStrength'
import './PasswordStrength.sass'

export default PasswordStrength
